import { DataType } from "@easydata/core";
/**
 * Represents Google data table class
 */
var GoogleDataConverter = /** @class */ (function () {
    /**
     * The default constructor.
     * @param data The table instance or its JSON representation.
     */
    function GoogleDataConverter(data) {
        if (!data) {
            data = {
                cols: [],
                rows: []
            };
        }
        if (typeof data === "string") {
            this.loadFromJSON(data);
        }
        else {
            this.tableObj = data;
        }
    }
    /**
     * Loads data table from JSON.
     * @param json The JSON representation.
     */
    GoogleDataConverter.prototype.loadFromJSON = function (json) {
        this.tableObj = JSON.parse(json);
    };
    /**
     * Saves data table to JSON.
     * @returns The JSON representation.
     */
    GoogleDataConverter.prototype.toJSON = function () {
        return JSON.stringify(this.tableObj);
    };
    /**
     * Gets the google data table object.
     * @returns The data table.
     */
    GoogleDataConverter.prototype.getObject = function () {
        return this.tableObj;
    };
    /**
     * Cheсks wether the table is empty
     * @returns `true` if the table is empty, `false` if it is not.
     */
    GoogleDataConverter.prototype.isEmpty = function () {
        return this.getNumberOfColumns() == 0 || this.getNumberOfRows() == 0;
    };
    /**
     * Gets the number of columns
     * @returns The number.
     */
    GoogleDataConverter.prototype.getNumberOfColumns = function () {
        return this.tableObj.cols.length;
    };
    /**
     * Gets the column object.
     * @param colIndex The column index.
     * @returns The column object.
     */
    GoogleDataConverter.prototype.getColumnObject = function (colIndex) {
        return colIndex < this.tableObj.cols.length ? this.tableObj.cols[colIndex] : null;
    };
    /**
     * Gets the column ID.
     * @param colIndex The column index.
     * @returns The column ID.
     */
    GoogleDataConverter.prototype.getColumnId = function (colIndex) {
        var col = this.getColumnObject(colIndex);
        return col ? col.id : null;
    };
    /**
     * Gets the column LABEL.
     * @param colIndex The column index.
     * @returns The column ID.
     */
    GoogleDataConverter.prototype.getColumnLabel = function (colIndex) {
        var col = this.getColumnObject(colIndex);
        return col ? col.label : null;
    };
    /**
     *  Gets the column type.
     * @param colIndex The column index.
     * @returns The column type.
     */
    GoogleDataConverter.prototype.getColumnType = function (colIndex) {
        var col = this.getColumnObject(colIndex);
        return col ? col.type : null;
    };
    /**
     * Gets the column properties.
     * @param colIndex The column index.
     * @returns The column properties.
     */
    GoogleDataConverter.prototype.getColumnProperties = function (colIndex) {
        var col = this.getColumnObject(colIndex);
        return col ? col.p : null;
    };
    /**
     * Gets the number of rows.
     * @returns The number.
     */
    GoogleDataConverter.prototype.getNumberOfRows = function () {
        return this.tableObj.rows.length;
    };
    GoogleDataConverter.prototype.convertValue = function (value, colIndex) {
        var colType = this.googleDataTypeToDataType(this.getColumnType(colIndex));
        if ([DataType.Date, DataType.DateTime, DataType.Time].includes(colType)) {
            return eval("new " + value);
        }
        return value;
    };
    /**
     *  Gets the value.
     * @param rowIndex
     * @param colIndex
     */
    GoogleDataConverter.prototype.getValue = function (rowIndex, colIndex) {
        var row = rowIndex < this.tableObj.rows.length ? this.tableObj.rows[rowIndex] : null;
        if (row) {
            var cell = colIndex < this.tableObj.cols.length ? row.c[colIndex] : null;
            if (cell) {
                return this.convertValue(cell.v, colIndex);
            }
        }
        return null;
    };
    GoogleDataConverter.prototype.getRow = function (rowIndex) {
        var _this = this;
        var googleRow = rowIndex < this.tableObj.rows.length ? this.tableObj.rows[rowIndex] : null;
        var googleCells = googleRow.c;
        var row = googleCells.map(function (obj, idx) { return _this.convertValue(obj.v, idx); }, this);
        return row;
    };
    GoogleDataConverter.prototype.convertTo = function (dataTable) {
        var colCount = this.getNumberOfColumns();
        for (var i = 0; i < colCount; i++) {
            dataTable.columns.add({
                id: this.getColumnId(i),
                label: this.getColumnLabel(i),
                type: this.googleDataTypeToDataType(this.getColumnType(i))
            });
        }
        var rowCount = this.getNumberOfRows();
        for (var i = 0; i < rowCount; i++) {
            dataTable.addRow(this.getRow(i));
        }
    };
    GoogleDataConverter.prototype.googleDataTypeToDataType = function (googleDataType) {
        switch (googleDataType) {
            case 'string':
                return DataType.String;
            case 'number':
                return DataType.Float;
            case 'boolean':
                return DataType.Bool;
            case 'date':
                return DataType.Date;
            case 'datetime':
                return DataType.DateTime;
            case 'timeofday':
                return DataType.Time;
            default:
                return DataType.String;
        }
    };
    return GoogleDataConverter;
}());
export { GoogleDataConverter };
//# sourceMappingURL=google_data_converter.js.map